/** ---------------------------------------------------------------------------------------
 * --  LICENSE AGREEMENT -- *
 This software is licensed under the following terms:

 * -- GRANT OF LICENSE | RESTRICTIONS -- *
 Subject to the terms and conditions of this license, the copyright holders
 hereby grant you a non-exclusive, non-transferable, revocable license to use,
 copy, modify, and distribute the software.
 You are expressly prohibited from selling or commercially exploiting the software.
 Unauthorized use, reproduction, or distribution of the software, or any part
 thereof, is strictly prohibited.

 * -- AUTHORIZED USERS | INTELLECTUAL PROPERTY -- *
 This license is granted only to the individual or entity to whom the software is
 directly distributed by the copyright holders. Any use by other individuals or
 entities is unauthorized and in violation of this license. The software is
 protected by copyright and other intellectual property laws.
 The copyright holders retain all rights, title, and interest in the software.

 * -- GOVERNING LAW -- *
 This license is governed by and construed in accordance with the laws of Romania.
 Any legal action or proceeding related to this license shall be brought exclusively
 in the courts of Romania.

 [Weddify x Diaphan Stationery] © [2024] All rights reserved.
 -------------------------------------------------------------------------------------- **/
'use client'
import React from 'react';
import AppStatic from "@/utils/AppStatic";
import Image from 'next/image';
import NotFoundImage from '@/assets/images/404-image.webp';

function App404() {
    return (
        <div className="flex items-center justify-center bg-[#FBFAF9] mt-16">
            <div className="text-center mb-16">
				<Image src={NotFoundImage} alt="Weddify by Diaphan 404 image" className="md:max-w-[500px]" priority={true}/>
                <h1 className="text-5xl">{AppStatic.heading404.ro.translation}</h1>
                <p>{AppStatic.message404.ro.translation}</p>
            </div>
        </div>
    );
}

export default App404;
